var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FAF5F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 14.5V13.9C23 13.0599 23 12.6399 22.8365 12.319C22.6927 12.0368 22.4632 11.8073 22.181 11.6635C21.8601 11.5 21.4401 11.5 20.6 11.5H19.4C18.5599 11.5 18.1399 11.5 17.819 11.6635C17.5368 11.8073 17.3073 12.0368 17.1635 12.319C17 12.6399 17 13.0599 17 13.9V14.5M18.5 18.625V22.375M21.5 18.625V22.375M13.25 14.5H26.75M25.25 14.5V22.9C25.25 24.1601 25.25 24.7902 25.0048 25.2715C24.789 25.6948 24.4448 26.039 24.0215 26.2548C23.5402 26.5 22.9101 26.5 21.65 26.5H18.35C17.0899 26.5 16.4598 26.5 15.9785 26.2548C15.5552 26.039 15.211 25.6948 14.9952 25.2715C14.75 24.7902 14.75 24.1601 14.75 22.9V14.5",
    stroke: "#1A1A1A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinSettingsIcon);
export default __webpack_public_path__ + "static/media/bin-settings-icon.d5a7dd60e9fb0ea39c5687fc58bca105.svg";
export { ForwardRef as ReactComponent };